type SettingsPageType =
  | "Publication"
  | "Monetization"
  | "Growth"
  | "Import/Export"

type SettingsPageLink = {
  title: SettingsPageType
  url: string
}

const links: SettingsPageLink[] = [
  {
    title: "Publication",
    url: "/blog",
  },
  {
    title: "Monetization",
    url: "/monetization",
  },
  {
    title: "Growth",
    url: "/growth",
  },
  {
    title: "Import/Export",
    url: "/import-export",
  },
]

export const settingsLinks: SettingsPageLink[] = links.map((l) => {
  return { title: l.title, url: getSettingsURL(l.title) }
})

function getSettingsURL(page: SettingsPageType): string {
  const url = links.find((l) => l.title === page)?.url

  return `/settings/publication` + url
}
